import Aurelia, { Registration } from 'aurelia';
import { RouterConfiguration } from '@aurelia/router-lite';
import { ValidationHtmlConfiguration } from '@aurelia/validation-html';
import { StateDefaultConfiguration } from '@aurelia/state';
import * as DsElements from './resources/elements';
import * as Extensions from './resources/extensions';
import * as ValueConverters from './resources/value-converters';
import * as Hooks from './resources/hooks';
import * as ActionHandlers from './state/action-handlers';
import { App } from './app';
import 'bootstrap';
import '@chicksgroup/web-components';
import '@chicksgroup/web-components-features';
import { IMetadataService, MetadataService } from './services/metadata-service';
import { initialState } from './state';
import { LazyLoadingHook } from './resources/hooks/images-hook';

Aurelia
    .register(
        RouterConfiguration.customize({
            useUrlFragmentHash: false,
        }),
        Registration.singleton(IMetadataService, MetadataService),
    )
    .register(ValueConverters)
    .register(ValidationHtmlConfiguration)
    .register(DsElements)
    .register(Extensions)
    .register(Hooks)
    .register(LazyLoadingHook)
    .register(
        StateDefaultConfiguration.init(
            initialState,
            ...ActionHandlers.allActionHandlers
        )
    )
    .app(App)
    .start();

